import React, { useEffect, useMemo, useState, useContext, ReactNode } from 'react';
import { Col, Layout, Row, Typography } from 'antd';
import { Link, useNavigate, useLocation } from 'react-router-dom';

import GlobalHeaderRight from 'components/theme_components/GlobalHeader/RightContent';
import { DownloadOutlined, MailOutlined } from '@ant-design/icons';

import './index.less';
import MainMenu from './MainMenu';
import { AuthContext } from 'components/Auth/Auth';
import getEnvValue from 'utils/getEnvValue';
import Alert from 'components/Alert';
import buildInfo from 'buildInfo';

const { Header, Content, Footer } = Layout;

const pathsExcludedFromLayout = [
  '/login',
  '/posphonesshop',
  '/dashboards',
  '/init_change_password',
];

type AntLayoutSFSProps = {
  children: ReactNode;
};

const AntLayoutSFS: React.FC<AntLayoutSFSProps> = ({ children }) => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const context = useContext(AuthContext);
  const [showWarning, setShowWarning] = useState(false);
  const [warningMessage, setWarningMessage] = useState('');
  const navigate = useNavigate();
  const [token, setToken] = useState(() => localStorage.getItem('token'));
  const [changePassword, setchangePassword] = useState(() =>
    localStorage.getItem('changepassword')
  );
  const { Text } = Typography;

  useEffect(() => {
    const sessionExpiration = localStorage.getItem('sessionExpirationMessage');
    if (sessionExpiration) {
      try {

        setWarningMessage(sessionExpiration.replace('(msgid:601)', ''));
        setShowWarning(true);

      } catch (e) {
        console.error('Error parsing sessionExpiration:', e);
      }
    }
  }, []);

  const handleWarningClick = () => {
    localStorage.setItem('changepassword', 'true');
    // Set in localStorage
    localStorage.setItem('changepassword', 'true');
    // Update the state directly as well
    setchangePassword('true');
    navigate('/init_change_password');
  };
  const handleCloseWarning = (e: React.MouseEvent) => {
    e.stopPropagation();
    setShowWarning(false);
  };
  const toggle = () => {
    setCollapsed(!collapsed);
  };

  const importAll = (r: any) => {
    let images: any = {};
    r.keys().map((item: any, index: any) => {
      images[item.replace('./', '')] = r(item);
    });
    return images;
  };

  const images: any = importAll(
    require.context('/src/assets/', false, /\.(png|jpg|jpe?g|svg)$/)
  );

  const isExcludedFromLayout = pathsExcludedFromLayout.includes(
    location.pathname
  );
  const buildDate =
    new Date(buildInfo.buildDate).getFullYear() +
    '/' +
    Number(new Date(buildInfo.buildDate).getMonth() + 1) +
    '/' +
    new Date(buildInfo.buildDate).getDate() +
    ' _ ' +
    new Date(buildInfo.buildDate).getHours() +
    ' h : ' +
    new Date(buildInfo.buildDate).getUTCMinutes() +
    ' m';


  const LendingLogo = useMemo(
    () => (
      <div className={'logo-sfs'} style={{ display: 'flex' }}>
        <Link to="/" style={{ display: 'flex' }}>
          <img
            // style={{ height: "67px" }}
            src={
              images[
              localStorage.getItem('logo') !== '' &&
                localStorage.getItem('logo') !== 'null' &&
                localStorage.getItem('logo') !== 'undefined'
                ? localStorage.getItem('logo')
                : getEnvValue('logo')
              ]
            }
            alt="logo"
          />
          {getEnvValue('platformetext') && <b>Platform</b>}
        </Link>
      </div>
    ),
    [localStorage.getItem('logo')]
  );

  return (
    !isExcludedFromLayout ? (



      <div>
        <Layout>
          {showWarning && (
            <Alert
              variant="warning"
              className="cursor-pointer mb-4"
              onClick={handleWarningClick}
            >
              <div className="flex items-center justify-between">
                <span>{warningMessage}</span>

              </div>
            </Alert>
          )}
          <Layout className={'siteLayout'}>

            <Header
              className="site-layout-background ut-header-wrapper ut-theme-header-wrapper"
            >

              <div className='ut-theme-header-left'>

                <div className='ut-theme-header-brand'>
                  <div className='ut-theme-header-brand-logo'>
                    {LendingLogo}
                  </div>
                </div>
                <div className='ut-menu-inner ut-theme-menu-wrapper'>
                  <MainMenu menuFromContext={context.menu} />
                </div>


              </div>


              <div className='ut-theme-header-right'>
                <GlobalHeaderRight />
              </div>






            </Header>

            <Content
              className="site-layout-background"
              style={{ marginBottom: 10 }}
            >
              {children}
            </Content>

          </Layout>
        </Layout>
        <div className='ut-theme-footer-wrapper' >
          <Row justify="center" align="middle">
            <Col span={2}>
              <span className={'hideOnMobileR'}>
                Version {"  "}
                {String(
                  JSON.stringify(require('../../../../package.json').version)
                ).replaceAll('"', '')

                }
              </span>
            </Col>
            <Col span={8}>
              <span >Mise à jour des données &ensp;&ensp;  {buildDate.toString()}{' '}</span>
            </Col>
            <Col span={9}>
              <span className='text-center'>Données affichées non contractuelles</span>
            </Col>
            <Col span={2}>
              <a href="mailto:support@example.com" className='text-right' style={{ marginRight: "15px" }}>
                <MailOutlined /> Contact
              </a>
            </Col>
            <Col span={3}>
              <a href="/guide.pdf" download >
                <DownloadOutlined /> Guide d’utilisation
              </a>
            </Col>
          </Row>

        </div>
      </div>
    ) : (
      <Layout className={'siteLayout'}>
        <Header
          className="site-layout-background"
          style={{
            margin: '0px 0px 0px 10px',
            padding: 0,
            height: '60px',
          }}
        >
          <GlobalHeaderRight isExcludedFromLayout={isExcludedFromLayout} />
        </Header>
        <Content
          className="site-layout-background"
          style={{
            overflow: 'scroll',
            height: '90vh',
            margin: '0px 0px 0px 0px',
            padding: 10,
            minHeight: 280,
          }}
        >
          {children}
        </Content>
      </Layout>
    )
  );
};

export default AntLayoutSFS;
